import {$dom} from "../../helpers/dom";
import api from "../../api/instance";
import {getChoice, resetChoice} from "../../helpers/_utilities";
import variables from "../../variables";

const {classNames, searchTypes} = variables;

export function handleRequest(detail) {
    const {form, submitBtn} = detail;
    const citySelectSelector = '#'+(form.getAttribute('id'))+' #js-landing-common-user-city';
    const defaultSelectSelector = '.js-landing-common-default-select';

    try {
        const {notify, formValidation, modal, searchSelect} = window?.currentPage?.components;

        $dom.addClass(submitBtn, classNames.lazyLoading);

        api({
            method: 'post',
            url: form.getAttribute('action') || '/goodsRequest',
            data: new FormData(form)
        })
            .then(({status, message}) => {
                if (status) {
                    modal.open(variables.ids.successMessageModal);
                    form.reset();
                    formValidation.validator && formValidation.validator.reset(form);
                    const cityChoice = getChoice(citySelectSelector);
                    const citySelectId = $dom.attr(citySelectSelector, 'id');                    

                    resetChoice(cityChoice);

                    if ($dom.exist(defaultSelectSelector, form)) {
                        $dom.callAll(defaultSelectSelector, selectGroup => {
                            const selectEl = $dom.get(variables.selectors.select, selectGroup);

                            selectEl && resetChoice(getChoice(selectEl), true);
                        }, form);
                    }

                    searchSelect.updateField(citySelectId, {page: 1});
                    searchSelect.makeRequest(searchTypes.cities, citySelectId)
                        .then(results => {
                            cityChoice.setChoices(results, 'value', 'label', true);
                            searchSelect.updateField(citySelectId, {page: 2});
                        })
                } else {
                    notify.show({
                        description: message,
                        status: 'error'
                    });
                }
            })
            .finally(() => $dom.removeClass(submitBtn, classNames.lazyLoading))
    } catch (e) {console.error(e)}
}


